import { render, staticRenderFns } from "./PackingListEmbView.vue?vue&type=template&id=bbacb6fe"
import script from "./PackingListEmbView.vue?vue&type=script&lang=js"
export * from "./PackingListEmbView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports